<script>
import apiEndpoints from "@/services/apiEndpoints";
import tableSearch from "@/mixins/tableSearch";
import router from "@/mixins/router";

export default {
  components: {
    CommonTableComponent: () => import("@/components/table.vue"),
  },
  mixins: [tableSearch, router],
  props: ["work_reservation", "dailyReport"],
  data() {
    return {
      listWorkOrder: [],
      dataSelected: {
        wasteOrServices: [],
      }
    }
  },
  created() {
    if (! this.dailyReport) {
      this.getData()
    }
  },
  methods: {
    async getData() {
      this.isLoading = true;
      const url = apiEndpoints.select_waste_or_service(this.caseId);
      const {status, data} = await this.$http.get(url, this.filters);

      if (status && data.result) {
        this.listWorkOrder = data.result;
      }
      this.isLoading = false;
    },
    filterSelected(data) {
      return data.filter(x => this.dataSelected.wasteOrServices.includes(x.wastes_or_services_by_work_order_id))
    }
  },
  computed: {
    headers() {
      return this.$constant.tableHeaders.work_reservation.wastes_or_services
    },
    caseId() {
      if (this.dailyReport) {
        return  this.dailyReport.case_id
      }
      return this.$route.params.case_id
    },
  },
  watch: {
    'work_reservation': {
      immediate: true,
      deep: true,
      handler: function(newValue) {
        this.dataSelected.wasteOrServices = newValue.wastes_or_services_by_work_reservation?.map(item => item.wastes_or_services_by_work_order_id) ?? []
      }
    },
    'dailyReport': {
      immediate: true,
      deep: true,
      handler: function(newValue) {
        if (newValue && newValue.case_id !== null && newValue.case_id !== undefined) {
          this.getData();
        }
      }
    },
  },
};
</script>
<template>
  <div>
    <p v-if="listWorkOrder.length && dataSelected.wasteOrServices.length"><strong>予約内容</strong></p>
    <CommonTableComponent :height-class="`table-wrapper-500`" v-if="listWorkOrder.length && dataSelected.wasteOrServices.length">
      <thead class="table-light">
      <tr>
        <th
          v-for="(item, index) in headers"
          :key="index"
          :class="[...getHeaderClass(item), 'text-center']"
        >
          <span v-html="item.text"> </span>
        </th>
      </tr>
      </thead>
      <tbody>
      <template
        v-for="(workOrder, indexWorkOrder) in listWorkOrder">
        <tr v-for="(wasteOrService, index) in filterSelected(workOrder.wasteOrServices)">
          <td :rowspan="workOrder.wasteOrServices.length" class="text-center" v-if="index===0">
            {{ workOrder.id }}
          </td>
          <td 
            :rowspan="workOrder.wasteOrServices.length"
            v-if="index===0"
          >
            <a @click.exact="
              redirectRouteTargetBlank(
                'projects.sales.instructions.detail',
                {
                  id: caseId,
                  work_order_id: workOrder.id
                },
                {readonly: true},
                ''
              )
            "
            class="cursor-pointer" href="javascript:void(0);">{{ workOrder.name }}</a>
          </td>
          <td :rowspan="workOrder.wasteOrServices.length" v-if="index===0">
                      <span v-if="workOrder.zz_work_order_type">
                        {{ workOrder.zz_work_order_type.work_order_type }}
                      </span>
          </td>
          <td class="text-center">
            <b-form-checkbox
              disabled
              v-model="dataSelected.wasteOrServices"
              :value="wasteOrService.wastes_or_services_by_work_order_id"
            ></b-form-checkbox>
          </td>
          <td>{{ wasteOrService.name }}</td>
          <td>{{ wasteOrService.waste_category_of_treatment_name_abbreviated }}</td>
          <td>{{ wasteOrService.vendor_sites_name_abbreviated }}</td>
          <td>{{ wasteOrService.treatment_method }}</td>
        </tr>
      </template>
      </tbody>
    </CommonTableComponent>
  </div>
</template>
